<div
	#mainElement
	class="component-field-input-radio show"
	[class.rd-touched]="valueSelected || valueSelected === false"
	[class.rd-error]="hasError"
	(mouseenter)="mouseenter()"
	(mouseleave)="mouseleave()"
>
	<section class="rd-section-body">
		@if (labelValue) {
			<div class="rd-icon">
				@if (isRequired) {
					<lbca-icon
						[class.rd-filled]="valueSelected || valueSelected === false"
						class="rd-light"
						size="small"
						name="lucide:asterisk"
					/>
				}
				<p class="rd-label">{{ labelValue }}</p>
				<div class="icon-box rd-icon-validation"></div>
			</div>
		}
		<div>
			@for (option of options; track option) {
				<label
					class="rd-template show"
					[class.flex]="!inlineFields"
					[class.inline-flex]="inlineFields"
					(mouseenter)="getFocus()"
					[class.disabled]="isDisabled"
					[class.readOnly]="isReadOnly"
				>
					<input
						type="radio"
						class="rd-field"
						[class.readOnly]="isReadOnly"
						[disabled]="isDisabled || isReadOnly"
						name="{{ labelValue + elementId }}"
						[checked]="isChecked(option.id)"
						(click)="selectOption($event, option)"
					/>
					<span [class.readOnly]="isReadOnly" class="chk chk-left"></span>
					<span [class.readOnly]="isReadOnly" class="chk-dot chk-dot-left"></span>
					<!-- <span class="chk-dot chk-dot-left" [class.fillDanger]="option.id=='false'||option.id==false"></span> -->
					<span [class.readOnly]="isReadOnly" class="chk-text">{{ option.label }}</span>
				</label>
			}
		</div>
	</section>
</div>
<span class="text-xs">{{ helperTextValue }}</span>
